import ProgramList from '@/components/program/ProgramList'
import ProgramCreate from '@/components/program/ProgramCreate'
import ProgramVue from '@/components/program/ProgramVue'
import ProgramEdit from '@/components/program/ProgramEdit'
import ProgramDiffusionEdit from '@/components/program/ProgramDiffusionEdit'
import ProgramDocumentEdit from '@/components/program/ProgramDocumentEdit'
import ProgramLotsImport from '@/components/program/ProgramLotsImport'
import ProgramChild from '@/components/program/ProgramChild'

export default [
  {
    path: '/programmes',
    name: 'ProgramList',
    component: ProgramList,
    meta: {
      parentName: 'Home',
      requiresAuth: true
    }
  },
  {
    path: '/programmes/creation',
    name: 'ProgramCreate',
    component: ProgramCreate,
    meta: {
      parentName: 'StockPrograms',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/programmes/:id/edition',
    name: 'ProgramEdit',
    component: ProgramEdit,
    meta: {
      parentName: 'ProgramVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/programmes/:id/documents',
    name: 'ProgramDocumentEdit',
    component: ProgramDocumentEdit,
    meta: {
      parentName: 'ProgramVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/programmes/:id',
    name: 'ProgramVue',
    component: ProgramVue,
    meta: {
      parentName: 'StockPrograms',
      requiresAuth: true,
      maxHeight: true
    }
  },
  {
    path: '/programmes/:id/diffusion',
    name: 'ProgramDiffusionEdit',
    component: ProgramDiffusionEdit,
    meta: {
      parentName: 'ProgramVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/programmes/:id/lots-import',
    name: 'ProgramLotsImport',
    component: ProgramLotsImport,
    meta: {
      parentName: 'ProgramVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  },
  {
    path: '/programmes/:id/lots-parkings',
    name: 'ProgramChild',
    component: ProgramChild,
    meta: {
      parentName: 'ProgramVue',
      requiresAuth: true,
      needProfile: ['admin', 'editor']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/programRouter.js